import {
  TTranslation,
} from './item-generic-settings.ts';

import {
  EAppId,
} from '@/types/app-type.ts';
import {
  ESettingsSectionType,
} from '@/types/settings.ts';

const translation: TTranslation = {
  [EAppId.TENANT_SETTINGS]: {
    [ESettingsSectionType.APP_OVERVIEW]: {
      title: 'App-Übersicht',
      subtitle: 'Die folgenden Einstellungen legen die App-Übersicht, die App-Seitenleiste und den Berechtigungsbaum der Benutzerverwaltung für alle Benutzer fest.',
      settingsMap: {
        appGrouping: {
          label: 'App-Gruppierung',
          tooltip: 'Legt fest, nach welchen Gruppen die Apps für alle Benutzer angeordnet werden.',
          choices: {
            Department: {
              title: 'Nach Abteilung',
              details: 'Arbeitsvorbereitung, Fertigung, Qualitätssicherung, Auswertung, Stammdaten, Administration',
            },
            Topic: {
              title: 'Nach Thema',
              details: 'Betrieb, Prozess, Daten/Analyse, Wartung, Konfiguration',
            },
          },
        },
      },
    },
  },
  [EAppId.REMOTE_CONTROL]: {
    [ESettingsSectionType.REMOTE_CONTROL_PT9800]: {
      title: 'PT9800 Controller',
      subtitle: 'Die folgenden Einstellungen bestimmen das Verhalten des PT9800-Controllers für jeden Benutzer.',
      settingsMap: {
        enforceBarcodeScanner: {
          label: 'Barcode scanner forcieren.',
          tooltip: 'Wenn angewählt, wird die Bestätigung von Teilen per Barcodescanner im Dialog zum Starten von Chargen erzwungen.',
        },
      },
    },
  },
};

export default translation;
